import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// Import slices here when created
// import cardsReducer from './slices/cardsSlice';
// import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    // Placeholder to silence "Store does not have a valid reducer" error until actual slices are created
    _app: (state = {}) => state,
    // cards: cardsReducer,
    // auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
